import { Typography } from '@mui/material';
import { useAuth0LoginRedirect } from '@hooks/useAuth0LoginRedirect';

export const LoginRedirect = () => {
  useAuth0LoginRedirect();

  return (
    <Typography variant="h5" component="h5">
      Signing in...
    </Typography>
  );
};
